// extracted by mini-css-extract-plugin
module.exports = {"container":"f0wSoC6gZDIczEyCvER_p","start":"_3A4g1Fw_1MLmc2pRFfX6f8","stars":"clDP5pA4rQHwg_1r40Ru0","center":"_3A7nlLtJ5IYGB3AlHbGTfD","end":"_3tlJrC3iPzMuayhHs2aYla"};